import ChurchBrand from "@/components/ChurchBrand";

export default function Header() {
  return (
    <header
      data-testid="app-header"
      className="relative w-full overflow-hidden"
      style={{
        backgroundImage:
          "linear-gradient(rgba(26,24,24,0.72), rgba(44,85,69,0.74)), url('https://images.unsplash.com/photo-1569292567773-229e2b7521ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxjaHVyY2glMjBjb21tdW5pdHklMjBwZW9wbGUlMjB3YXJtfGVufDB8fHx8MTc4MjE1ODE1Nnww&ixlib=rb-4.1.0&q=85')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14 text-center text-white">
        <ChurchBrand size="lg" className="mb-5 text-[#F8E1B5]" />

        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
          Sobrellevad los Unos<br className="hidden sm:block" /> las Cargas de los Otros
        </h1>
        <p className="mt-5 font-serif italic text-lg sm:text-xl leading-relaxed max-w-2xl mx-auto">
          &ldquo;Sobrellevad los unos las cargas de los otros, y cumplid así la ley de Cristo.&rdquo;
        </p>
        <p className="mt-2 text-base font-semibold text-[#F8E1B5]">— Gálatas 6:2</p>
      </div>
    </header>
  );
}
